import styled from 'styled-components';
import { TBadgeSC } from './badge';
import theme from '../../constants/theme';

export const DEVICES_COLORS = {
  Garmin: '#000000',
  fitbit: '#75C1C2',
  ihealth: '#FF5200',
  omron: '#166FC0',
};

export const BadgeSC = styled.span<TBadgeSC>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  min-width: 75px;
  border-radius: 12px;
  background: ${({ type }) => getBadgeStyle(type).background};
  color: ${({ type }) => getBadgeStyle(type).color};
  font-size: 12px;
  font-weight: 800;
`;

function getBadgeStyle(badgeType: string | undefined) {
  if (!badgeType) {
    return {
      color: 'rgba(51, 61, 108, 0.6)',
      background: 'rgba(51, 61, 108, 0.08)',
    };
  }

  switch (badgeType) {
    case 'Garmin':
      return {
        color: '#ffffff',
        background: DEVICES_COLORS.Garmin,
      };

    case 'fitbit':
      return {
        color: '#ffffff',
        background: DEVICES_COLORS.fitbit,
      };

    case 'ihealth':
      return {
        color: '#ffffff',
        background: DEVICES_COLORS.ihealth,
      };

    case 'omron':
      return {
        color: '#ffffff',
        background: DEVICES_COLORS.omron,
      };

    case 'PRIMARY':
      return {
        color: theme.colors.primary,
        background: 'rgba(106, 213, 229, 0.1)',
      };

    case 'SECONDARY':
      return {
        color: 'rgba(51, 61, 108, 0.6)',
        background: 'rgba(51, 61, 108, 0.08)',
      };

    case 'Client':
      return {
        color: theme.colors.primary,
        background: 'rgba(106, 213, 229, 0.1)',
      };

    default:
      return {
        color: 'rgba(51, 61, 108, 0.6)',
        background: 'rgba(51, 61, 108, 0.08)',
      };
  }
}
